import { getEnv } from '../../../shared/utilities/env';

const travelSuiteBase = getEnv('TRAVEL_SUITE_URL') ?? 'https://travelsuite.evaneos.com';
export const homeBasename = getEnv('HOME_APP_BASENAME') ?? '/home';

export const LOGIN_URL = `${travelSuiteBase}/login`;
export const PARTNER_URL = 'https://recrutement-dmc.evaneos.fr/';
export const PRIVACY_POLICY_PATH = `${homeBasename}/privacy-policy`;
export const DPO_EMAIL = 'data-privacy@evaneos.com';
